/* eslint-disable angular/controller-name, angular/controller-as */

angular.module("dx.webapp.node").controller("DxNodeIntegrationsController", function NodeIntegrationsController(
	$scope,
	$http,
	$window,
	dxLocalize
) {
	"use strict";

	$scope.credentialsLoaded = false;
	$scope.credentials = {};
	$scope.isEnabled = false;
	$scope.errorMessage = "";
	$scope.showOAuthSecretKey = false;

	$scope.toggleOAuthSecretKey = function toggleOAuthSecretKey() {
		$scope.showOAuthSecretKey = !$scope.showOAuthSecretKey;
	};

	// window.location.origin is not reliable in IE, so here is a shim
	// see: http://stackoverflow.com/questions/22564167/window-location-origin-gives-wrong-value-when-using-ie
	var origin = $window.location.protocol + "//" + $window.location.hostname + ($window.location.port ? ":" + $window.location.port : "");
	$scope.xmlURL = origin + "/lti/lti.xml";

	$scope.helpUrl = dxLocalize.getLanguage() === "sv" ?
		"https://support.digiexam.se/hc/sv/sections/202415385-LTI" :
		"https://support.digiexam.se/hc/en-us/sections/202415385-LTI";

	$scope.enableLTI = function enableLTI() {
		$scope.credentials.isEnabled = true;
		setLTICredentials($scope.credentials, false);
	};

	$scope.resetLTI = function resetLTI() {
		$scope.credentials.isEnabled = true;
		setLTICredentials($scope.credentials, true);
	};

	$scope.disableLTI = function disableLTI() {
		$scope.credentials.isEnabled = false;
		setLTICredentials($scope.credentials, false);
	};

	function setLTICredentials(credentials, resetCredentials) {
		$http.post("/node/" + $scope.nodeId + "/lticredentials/?resetCredentials=" + resetCredentials, credentials).then(loadSuccess, loadError);
	}

	function loadNodeLTICredentials() {
		$http.get("/node/" + $scope.nodeId + "/lticredentials").then(loadSuccess, loadError);
	}

	function loadSuccess(response) {
		$scope.credentials = response.data;
		$scope.isEnabled = $scope.credentials.isEnabled;
		$scope.credentialsLoaded = true;
		$scope.errorMessage = "";
	}

	function loadError() {
		$scope.errorMessage = "SomethingWentWrong";
	}

	loadNodeLTICredentials();
});
